/**
 * The CTC job page shows a point-in-time financial snapshot: it is read fresh
 * on every visit, never served from a warm cache, and never refetched behind
 * the user's back while they are reading it.
 */
export const ctcSnapshotOptions = {
  gcTime: 0,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

export type CtcQueryOverrides = {
  enabled?: boolean;
  gcTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
};
